import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

// Signing out is a route rather than a click handler, so a page holding unsaved work can
// stop it and the admin can choose to stay (#848).
const SignOutRoute = () => {
  const { signOut } = useAuthenticator();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return; // StrictMode runs effects twice in dev
    done.current = true;
    signOut();
    navigate('/', { replace: true });
  }, [signOut, navigate]);
  return null;
};

export default SignOutRoute;
